export default "__VITE_ASSET__T_RLuY1U__"